import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import { sendProductForm } from 'helpers/addToCartButton';
import store from 'store';
export default class AddToWishlist extends Component {
    loading;
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.addToWishlistButton[method]('click', this.toggle);
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this.parent
        };
    }
    getModulesMap() {
        return {
            form: ['.form', Form]
        };
    }
    initialized() {
        super.initialized();
    }
    toggle = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
        const parentModules = this.parent?.modules;
        const form = this.modules.form ||
            parentModules?.form ||
            this.parent?.parent?.modules?.form ||
            parentModules?.forms?.find((form) => form.el.contains(this.refs.addToWishlistButton) || form.el.getAttribute('id') === this.refs.addToWishlistButton.getAttribute('form'));
        sendProductForm({
            submitter: this.refs.addToWishlistButton,
            form: this.modules.form || form,
            action: this.refs.addToWishlistButton.dataset.action,
            isWishlist: true,
            callback: this.onSent
        });
    };
    setState = (active) => {
        this.el.classList.toggle('active', active);
        this.refs.addToWishlistButton.classList.toggle('toggle', active);
        this.refs.wishlistQuantity.value = active ? '0' : '1';
    };
    onSent = ({ data, xhr }) => {
        if (!data.error && data.auth !== '0') {
            const active = !this.el.classList.contains('active');
            this.setState(active);
            this.emit('toggle', {
                xhr,
                active
            });
        }
        else {
            const login = xhr.response.querySelector('[data-page="Auth"]');
            if (login) {
                const { panel } = store.routers.get();
                panel.inject(this.refs.addToWishlistButton.dataset.action, xhr);
            }
        }
    };
}
